import React, { useState } from 'react';
import { IconButton, Paper, Fade } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Icon from '@mdi/react';
import { mdiChatOutline, mdiHelpCircleOutline } from '@mdi/js';
import { useLocation } from 'react-router-dom';
import ChatDialog from './ChatDialog';

const ChatLauncher = () => {
  const location = useLocation();
  const isMobile = window.innerWidth < 700;
  const styles = useStyles({ left: !isMobile });
  const [chatType, setChatType] = useState('');
  const [chatOpen, setChatOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Only show on dashboard routes
  if (!location.pathname.startsWith('/dashboard')) {
    return null;
  }

  const handleOptionClick = (type) => {
    setChatType(type);
    setChatOpen(true);
    setMenuOpen(false);
  };

  return (
    <>
      <div
        className={styles.container}
        onMouseEnter={() => setMenuOpen(true)}
        onMouseLeave={() => setMenuOpen(false)}
      >
        <IconButton
          onClick={() => setMenuOpen(true)}
          size='small'
          className={styles.button}
        >
          <Icon path={mdiChatOutline} size={1} />
        </IconButton>

        {/* Absolutely positioned menu */}
        <Fade in={menuOpen}>
          <Paper className={styles.menu} elevation={3}>
            <div className={styles.header}>
              <Icon
                path={mdiHelpCircleOutline}
                size={0.9}
                style={{ marginRight: 6 }}
              />
              Ask GPT about
            </div>
            <div
              className={styles.menuItem}
              onClick={() => handleOptionClick('pipeline')}
            >
              My Pipeline
            </div>
            <div
              className={styles.menuItem}
              onClick={() => handleOptionClick('guideline')}
            >
              NQM Investor Guidelines
            </div>
          </Paper>
        </Fade>
      </div>

      {chatOpen && (
        <ChatDialog
          open={chatOpen}
          onClose={() => setChatOpen(false)}
          chatType={chatType}
        />
      )}
    </>
  );
};

const useStyles = makeStyles(() => ({
  container: {
    position: 'fixed',
    bottom: 8,
    right: (params) => (params.left ? 'initial' : 8),
    left: (params) => (params.left ? 8 : 'initial'),
    zIndex: 1500,
  },
  button: {
    height: 32,
    width: 32,
  },
  menu: {
    position: 'absolute',
    bottom: 40,
    backgroundColor: '#fff',
    borderRadius: 8,
    right: (params) => (params.left ? 'initial' : 0),
    left: (params) => (params.left ? 0 : 'initial'),
    boxShadow: '0 3px 6px rgba(0,0,0,0.16)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    minWidth: 220, // make menu wider
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 600,
    fontSize: 14,
    padding: '10px 12px',
    borderBottom: '1px solid #eee',
  },
  menuItem: {
    padding: '8px 12px',
    cursor: 'pointer',
    fontSize: 13,
    transition: 'background 0.2s',
    '&:hover': {
      backgroundColor: '#f0f0f0',
    },
  },
}));

export default ChatLauncher;
